<h1 mat-dialog-title>
  <T str="Delete"></T>
</h1>

<div mat-dialog-content>
  <p>
    <T str="Are you sure you want to delete this checklist and all it's items? (completed items will be archived)"></T>
  </p>
  <p>
    <mat-checkbox [(ngModel)]="completeAndArchiveCheck">
      <T str="Also complete and archive all connected cases?"></T>
    </mat-checkbox>
  </p>
</div>

<div mat-dialog-actions>
  <button
    type="button"
    mat-button
    [mat-dialog-close]="{ del: false, completeAndArchiveCheck: completeAndArchiveCheck }">
    <T str="No"></T>
  </button>
  <button
    type="button"
    mat-raised-button
    color="warn"
    [mat-dialog-close]="{ del: true, completeAndArchiveCheck: completeAndArchiveCheck }"
    cdkFocusInitial>
    <T str="Delete"></T>
  </button>
</div>
